import { Component, OnInit } from '@angular/core';
import { LanguageService } from 'app/_services/language.service';

@Component({
  selector: 'fury-video-conf',
  templateUrl: './video-conf.component.html',
  styleUrls: ['./video-conf.component.scss']
})
export class VideoConfComponent implements OnInit {

  constructor(public languageService : LanguageService) { }

  ngOnInit() {
    // This is intentional
  }

}
